export default __webpack_public_path__ + "static/media/info.44b7b3ef.svg";